import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { track } from '@/lib/analytics';
import { useAuth } from '../hooks/use-auth';
import { AuthModal, useAuthModal } from './AuthModal';

/**
 * O lado direito do header: "Sair" para quem tem sessão, "Entrar" para quem
 * não tem. É o caminho de quem volta dias depois — entra por aqui e cai no
 * painel. (Não há botão "Minha conta": quem tem sessão chega ao painel pelo
 * fim do ensaio ou do gabarito, ou entrando de novo.)
 *
 * Fica fora do `LpShell` (que é `shared` e não conhece sessão): cada página o
 * passa em `headerRight`.
 */
export function HeaderAccount({ extra }: { extra?: ReactNode }) {
  const { user, isRestoring, signOut } = useAuth();
  const navigate = useNavigate();
  const { open, modalProps } = useAuthModal('login', () =>
    navigate('/minha-conta'),
  );

  // Sem esperar o restore, quem tem sessão veria "Entrar" piscar.
  if (isRestoring) return <>{extra}</>;

  return (
    <>
      {extra}
      {user ? (
        <>
          <button
            type="button"
            className="ghost"
            onClick={() => {
              track({ event: 'logout' });
              void signOut().then(() => navigate('/'));
            }}
          >
            Sair
          </button>
        </>
      ) : (
        <button
          type="button"
          className="ghost"
          onClick={() => open({ kind: 'sign-in' })}
        >
          Entrar
        </button>
      )}
      <AuthModal {...modalProps} />
    </>
  );
}
